<template>
	<div>
		<div v-show="streamedContent" ref="chatcontainer" class="markdown-body" v-html = "render(streamedContent)"></div>
		<div v-show="!streamedContent && isLoading" >检索中....</div>
	</div>
</template>
<style>
	.markdown-body {
		/* 		background: white;
		border-radius: 12px;
		padding: 16px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
		font-size: 15px;
		line-height: 1.6;
		color: #333;
		text-align: left; */
	}
	
	.markdown-body img {
		width:200px
	}
	/* 表格样式 */
	.markdown-body table {
		width: 100%;
		border-collapse: collapse;
		font-size: 14px;
		overflow-x: auto;
		margin: 16px 0;
		border-radius: 8px;
		border: 1px solid #e0e0e0;
	}
	
	.markdown-body th {
		background: #f8f9fa;
		font-weight: 600;
		padding: 12px;
		text-align: center;
		border: 1px solid #e0e0e0;
	}
	
	.markdown-body td {
		padding: 12px;
		text-align: center;
		border: 1px solid #e0e0e0;
		min-width: 100px;
		max-width: 220px;
		overflow-wrap: break-word;
	}
	
	.markdown-body tr:last-child td {
		border: 1px solid #e0e0e0;
	}
	
	/* 标题样式 */
	.markdown-body h1 {
		font-size: 24px;
		margin: 20px 0 10px;
		padding-bottom: 8px;
		border-bottom: 2px solid #f0f0f0;
	}
	
	.markdown-body h2 {
		font-size: 20px;
		margin: 18px 0 8px;
	}
	
	.markdown-body h3 {
		font-size: 18px;
		margin: 16px 0 6px;
	}
	
	/* 列表样式 */
	.markdown-list {
		padding-left: 20px;
		margin: 12px 0;
	}
	
	.markdown-list li {
		margin: 6px 0;
	}
	
	/* 引用块样式 */
	.markdown-blockquote {
		margin: 16px 0;
		padding: 12px 16px;
		background: #f8f9fa;
		border-left: 4px solid #4caf50;
		border-radius: 4px;
		color: #555;
	}
	
	.markdown-attachment-image {
		width: 200px;
		box-shadow: 0px 0px 8px gray;
	}
</style>
<script>
	import html2canvas from 'html2canvas'
	import store from '@/store/store.js';
	import {
		marked
	} from 'marked'
	export default {
		props: {

		},
		data() {
			return {
				param:{},
				streamedContent: '', // 用于累积显示的内容
				isLoading: false,
				controller: null, // 用于中止请求的 AbortController
			};
		},
		methods: {
			render(content) {
				const renderer = new marked.Renderer();
				// 2. 保存原始的 link 渲染函数
				const linkRenderer = renderer.link;
				// 3. 重写 link 方法
				renderer.link = (href, title, text) => {
					const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
					const isImageLink = href.href && imageExtensions.some(ext => href.href.toLowerCase().includes(
					ext));
			
					if (isImageLink) {
						// 返回带链接的图片，点击在新窗口打开原图
						return `</br><a href="${href.href}" target="_blank" rel="noopener noreferrer" class="image-link">
				    <img src="${href.href}" alt="${text || '附件图片'}" class="markdown-attachment-image">
				</a>`;
					}
			
					const html = linkRenderer.call(renderer, href, title, text);
					return html.replace(/^<a /, '</br><a target="_blank" rel="noopener noreferrer" ');
				};
			
				// 4. 将自定义渲染器设置为选项
				marked.setOptions({
					renderer
				});
			
			
				marked.setOptions({
					breaks: true,
					gfm: true,
					headerIds: false,
					mangle: false,
					smartLists: true,
					smartypants: true,
				});
			
				return marked(content, {
					breaks: true,
					gfm: true,
					tables: true
				})
			},
			async startStream() {
				this.streamedContent = '';
				this.isLoading = true;
				this.$emit('loading',true)

				// 创建一个 AbortController 实例，以便可以手动停止请求
				this.controller = new AbortController();
				const {
					signal
				} = this.controller;

				try {
					const response = await fetch(window.config.baseURL + '/admin/goodsknowledge/aichat', {
						method: 'POST',
						signal,
						headers: {
							'Content-Type': 'application/json',
							'Accept': 'text/event-stream',
							'token':window.localStorage.getItem(store.store.state.token)
						},
						body: JSON.stringify(this.param)
					});

					if (!response.ok) {
						this.$message.error('HTTP error! '.response.status)
					}
				
					// 获取响应的读取器
					const reader = response.body.getReader();
					const decoder = new TextDecoder('utf-8');
					let buffer = ''; // 用于处理可能跨块的数据
			
					// 递归读取数据块
					const read = async () => {
						try {
							const {
								done,
								value
							} = await reader.read();

							if (done) {
								
								this.isLoading = false;
								this.$emit('loading',false)
								this.controller = null;
								return;
							}

							// 解码接收到的二进制数据块
							buffer += decoder.decode(value, {
								stream: true
							});

							// 解析 SSE 格式的消息 (以 "data: " 开头，以 "\n\n" 结束)
							const lines = buffer.split('\n');

							// 处理所有完整的行，保留最后可能不完整的行
							for (let i = 0; i < lines.length - 1; i++) {
								const line = lines[i].trim();
								if (line.startsWith('data: ')) {
									const dataStr = line.slice(6); // 去掉 "data: " 前缀

									// 检查是否是结束标记
									if (dataStr === '[DONE]') {
										console.log('Received [DONE] signal');
										console.log(this.streamedContent);
										this.isLoading = false;
										this.$emit('loading',false)
										this.controller = null;
										reader.cancel();
										return;
									}

									try {
										const data = JSON.parse(dataStr);
										// DeepSeek API 返回的数据格式
										if (data.choices && data.choices[0] && data.choices[0].delta) {
											const content = data.choices[0].delta.content;
											if (content) {
												// 将内容追加到显示区域
												this.streamedContent += content;
											}
										}
									} catch (e) {
										// 如果不是 JSON 格式，可能是纯文本
										if (dataStr && dataStr !== '[DONE]') {
											this.streamedContent += dataStr;
										}
									}
								}
							}

							// 保留最后一行（可能不完整）到缓冲区
							buffer = lines[lines.length - 1];

							// 继续读取下一个数据块
							await read();
						} catch (error) {
							//this.$message.error('Read error:', error)
							this.isLoading = false;
							this.$emit('loading',false)
							this.controller = null;
						}
					};

					await read();

				} catch (error) {
					if (error.name === 'AbortError') {
						console.log('Fetch aborted');
					} else {
						console.error('Fetch error:', error);
					}
					this.isLoading = false;
					this.$emit('loading',false)
					this.controller = null;
				}
			},
			stopStream() {
				if (this.controller) {
					this.controller.abort(); // 中止请求
					this.isLoading = false;
					this.$emit('loading',false)
					this.controller = null;
				}
			},
			createHB(){
				html2canvas(this.$refs.chatcontainer).then(canvas => {
					let base64 = canvas.toDataURL()
					console.log(base64)
				});
				
			}
		},
		beforeDestroy() {
			// 组件销毁前中止未完成的请求
			this.stopStream();
		},
	};
</script>